// ─── Cart System ─────────────────────────────────────

const CART_KEY = 'vv_cart';
const WA_NUMBERS = {
  'btn-wa-axel': '528119120415',
  'btn-wa-alen': '528182095645',
};

function getCart() {
  try { return JSON.parse(localStorage.getItem(CART_KEY)) || []; }
  catch { return []; }
}

function saveCart(cart) {
  localStorage.setItem(CART_KEY, JSON.stringify(cart));
  renderCart();
}

function addToCart(id, title, price) {
  const cart = getCart();
  const existing = cart.find(i => i.id == id);
  if (existing) {
    existing.qty += 1;
  } else {
    cart.push({ id, title, price: Number(price), qty: 1 });
  }
  saveCart(cart);
  openCart();
}

function removeFromCart(id) {
  saveCart(getCart().filter(i => i.id != id));
}

function updateQty(id, qty) {
  if (qty < 1) { removeFromCart(id); return; }
  const cart = getCart();
  const item = cart.find(i => i.id == id);
  if (item) { item.qty = qty; saveCart(cart); }
}

function renderCart() {
  const cart = getCart();
  const count = cart.reduce((s, i) => s + i.qty, 0);
  const total = cart.reduce((s, i) => s + i.price * i.qty, 0);

  const countEl = document.getElementById('cart-count');
  if (countEl) {
    countEl.textContent = count;
    countEl.hidden = count === 0;
  }

  const itemsEl = document.getElementById('cart-items');
  if (!itemsEl) return;

  if (cart.length === 0) {
    itemsEl.innerHTML = '<p class="cart-empty">Tu carrito está vacío</p>';
    const foot = document.getElementById('cart-footer');
    if (foot) foot.hidden = true;
    return;
  }

  itemsEl.innerHTML = cart.map(item => `
    <div class="cart-item">
      <div class="cart-item__info">
        <span class="cart-item__name">${item.title}</span>
        <span class="cart-item__unit">$${item.price} c/u</span>
      </div>
      <div class="cart-item__controls">
        <button class="qty-btn" onclick="updateQty('${item.id}', ${item.qty - 1})">−</button>
        <span class="qty-val">${item.qty}</span>
        <button class="qty-btn" onclick="updateQty('${item.id}', ${item.qty + 1})">+</button>
        <button class="remove-btn" onclick="removeFromCart('${item.id}')" aria-label="Eliminar">✕</button>
      </div>
    </div>
  `).join('');

  const foot = document.getElementById('cart-footer');
  if (foot) foot.hidden = false;

  const totalEl = document.getElementById('cart-total');
  if (totalEl) totalEl.textContent = total.toLocaleString('es-MX');

  const lines = cart.map(i =>
    `${i.qty} ${i.title.replace(/\s+[—–-]\s+/, ' / ')}`
  ).join('\n');
  const msg = encodeURIComponent(
    `Me gustaría ordenar:\n\n${lines}\n\nTotal: $${total.toLocaleString('es-MX')}`
  );
  Object.entries(WA_NUMBERS).forEach(([id, num]) => {
    const el = document.getElementById(id);
    if (el) el.href = `https://wa.me/${num}?text=${msg}`;
  });
}

function openCart() {
  document.getElementById('cart-drawer')?.classList.add('is-open');
  document.getElementById('cart-overlay')?.classList.add('is-open');
  document.getElementById('cart-toggle')?.classList.add('is-open');
}

function closeCart() {
  document.getElementById('cart-drawer')?.classList.remove('is-open');
  document.getElementById('cart-overlay')?.classList.remove('is-open');
  document.getElementById('cart-toggle')?.classList.remove('is-open');
}

// ─── FAQ Accordion ────────────────────────────────

document.querySelectorAll('.faq__question').forEach(btn => {
  btn.addEventListener('click', () => {
    const item = btn.closest('.faq__item');
    const isOpen = item.classList.contains('open');
    document.querySelectorAll('.faq__item.open').forEach(el => el.classList.remove('open'));
    if (!isOpen) item.classList.add('open');
  });
});

// ─── Smooth scroll ────────────────────────────────

document.querySelectorAll('a[href^="#"]').forEach(link => {
  link.addEventListener('click', e => {
    const target = document.querySelector(link.getAttribute('href'));
    if (!target) return;
    e.preventDefault();
    const offset = parseInt(getComputedStyle(document.documentElement)
      .getPropertyValue('--header-h')) || 60;
    const top = target.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top, behavior: 'smooth' });
  });
});

// ─── Hero video fallback ──────────────────────────

const heroVideo = document.querySelector('.hero__video-bg video');
if (heroVideo) {
  heroVideo.addEventListener('error', () => {
    heroVideo.closest('.hero').classList.add('hero--no-video');
    heroVideo.closest('.hero__video-bg').style.display = 'none';
  });
}

// ─── Init cart ────────────────────────────────────

renderCart();

document.getElementById('cart-toggle')?.addEventListener('click', () => {
  document.getElementById('cart-drawer')?.classList.contains('is-open')
    ? closeCart()
    : openCart();
});

document.getElementById('cart-close')?.addEventListener('click', closeCart);
document.getElementById('cart-overlay')?.addEventListener('click', closeCart);

// ─── Swipe para cerrar carrito ────────────────────
let _swipeStartX = 0;
document.getElementById('cart-drawer')?.addEventListener('touchstart', e => {
  _swipeStartX = e.touches[0].clientX;
}, { passive: true });
document.getElementById('cart-drawer')?.addEventListener('touchend', e => {
  if (e.changedTouches[0].clientX - _swipeStartX > 80) closeCart();
}, { passive: true });

// ─── Menú lateral ────────────────────────────────
const menuToggle = document.getElementById('menu-toggle');
const menuDrawer = document.getElementById('menu-drawer');
const menuOverlay = document.getElementById('menu-overlay');

function openMenu() {
  menuDrawer?.classList.add('is-open');
  menuOverlay?.classList.add('is-open');
  menuToggle?.classList.add('is-open');
  menuToggle?.setAttribute('aria-expanded', 'true');
  menuDrawer?.setAttribute('aria-hidden', 'false');
}
function closeMenu() {
  menuDrawer?.classList.remove('is-open');
  menuOverlay?.classList.remove('is-open');
  menuToggle?.classList.remove('is-open');
  menuToggle?.setAttribute('aria-expanded', 'false');
  menuDrawer?.setAttribute('aria-hidden', 'true');
}

menuToggle?.addEventListener('click', () => {
  menuDrawer?.classList.contains('is-open') ? closeMenu() : openMenu();
});
document.getElementById('menu-close')?.addEventListener('click', closeMenu);
menuOverlay?.addEventListener('click', closeMenu);

// Swipe izquierda para cerrar menú
let _menuSwipeX = 0;
menuDrawer?.addEventListener('touchstart', e => {
  _menuSwipeX = e.touches[0].clientX;
}, { passive: true });
menuDrawer?.addEventListener('touchend', e => {
  if (_menuSwipeX - e.changedTouches[0].clientX > 80) closeMenu();
}, { passive: true });

// ─── Modales (Buzón / Grupos) ────────────────────
function openModal(name) {
  const overlay = document.getElementById(`${name}-overlay`);
  if (!overlay) return;
  overlay.classList.add('is-open');
  document.body.style.overflow = 'hidden';
  closeMenu();
}
function closeModal(name) {
  const overlay = document.getElementById(`${name}-overlay`);
  if (!overlay) return;
  overlay.classList.remove('is-open');
  document.body.style.overflow = '';
}

document.getElementById('open-buzon')?.addEventListener('click', () => openModal('buzon'));
document.getElementById('open-grupos')?.addEventListener('click', () => openModal('grupos'));

document.querySelectorAll('[data-modal-close]').forEach(btn => {
  btn.addEventListener('click', () => closeModal(btn.dataset.modalClose));
});

// Click fuera del .modal cierra
document.querySelectorAll('.modal-overlay').forEach(ov => {
  ov.addEventListener('click', e => {
    if (e.target === ov) {
      const id = ov.id.replace('-overlay', '');
      closeModal(id);
    }
  });
});

// ESC cierra cualquier modal/menu abierto
document.addEventListener('keydown', e => {
  if (e.key !== 'Escape') return;
  document.querySelectorAll('.modal-overlay.is-open').forEach(ov => {
    closeModal(ov.id.replace('-overlay', ''));
  });
  if (menuDrawer?.classList.contains('is-open')) closeMenu();
});

// ─── Buzón: toggle anónimo + submit ──────────────
const BUZON_WEBHOOK_URL = 'https://humberto2121.app.n8n.cloud/webhook/buzon-vvmty';

const buzonAnon = document.getElementById('buzon-anon');
const buzonFields = document.getElementById('buzon-fields');
const buzonForm = document.getElementById('buzon-form');
const buzonSubmit = document.getElementById('buzon-submit');
const buzonStatus = document.getElementById('buzon-status');

buzonAnon?.addEventListener('change', () => {
  if (buzonAnon.checked) {
    buzonFields?.classList.add('is-hidden');
  } else {
    buzonFields?.classList.remove('is-hidden');
  }
});

function showBuzonStatus(text, type) {
  if (!buzonStatus) return;
  buzonStatus.textContent = text;
  buzonStatus.className = 'buzon-status ' + (type === 'ok' ? 'is-ok' : 'is-error');
  buzonStatus.hidden = false;
}

buzonForm?.addEventListener('submit', async e => {
  e.preventDefault();
  const anon = buzonAnon?.checked || false;
  const nombre = document.getElementById('buzon-nombre')?.value.trim() || '';
  const tel = document.getElementById('buzon-tel')?.value.trim() || '';
  const comentario = document.getElementById('buzon-comentario')?.value.trim() || '';

  if (!comentario) {
    showBuzonStatus('Escribe tu comentario para enviar.', 'error');
    return;
  }
  if (!anon && (!nombre || !tel)) {
    showBuzonStatus('Pon tu nombre y teléfono, o marca "Enviar como anónimo".', 'error');
    return;
  }

  buzonSubmit.disabled = true;
  buzonSubmit.textContent = 'Enviando...';
  buzonStatus.hidden = true;

  try {
    const res = await fetch(BUZON_WEBHOOK_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        anonimo: anon,
        nombre: anon ? '' : nombre,
        telefono: anon ? '' : tel,
        comentario,
        origen: window.location.href,
        fecha: new Date().toISOString(),
      }),
    });
    if (!res.ok) throw new Error('http ' + res.status);
    showBuzonStatus('¡Gracias! Tu mensaje llegó. Te leemos.', 'ok');
    buzonForm.reset();
    buzonFields?.classList.remove('is-hidden');
  } catch (err) {
    showBuzonStatus('No pudimos enviar. Intenta de nuevo en un momento.', 'error');
  } finally {
    buzonSubmit.disabled = false;
    buzonSubmit.textContent = 'Enviar';
  }
});
